export default function EnterpriseThreatAssessmentController(
  $q,
  $scope,
  bcpDataService,
  loaderService,
  performThreatAssessmentDialog,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handlePerformThreatAssessment = _handlePerformThreatAssessment;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initPermissions() {
    vm.canExpand = vm.status !== 'Threat Assessment Not Started';
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshBCPThreatAssessments',
      _refreshAssessmentThreats
    );
  }

  function _refreshAssessmentThreats() {
    const dfdRefresh = $q.defer();

    const dfdThreatOptions = _refreshThreatOptions();

    dfdThreatOptions.then(() => {
      _refreshThreats().then(dfdRefresh.resolve);
    });

    return dfdRefresh.promise;
  }

  function _refreshThreats() {
    const dfdThreats = $q.defer();

    bcpDataService.getThreats(
      vm.assessmentId
    ).then((response) => {
      vm.assessmentThreats = response.data.result;
      dfdThreats.resolve();
    });

    return dfdThreats.promise;
  }

  function _refreshThreatOptions() {
    const dfdOptions = $q.defer();
    if (!vm.threatOptions) {
      loaderService.showViewLoader = true;
      bcpDataService.getThreatOptions().then((response) => {
        vm.threatOptions = response.data;
        loaderService.showViewLoader = false;
        dfdOptions.resolve();
      });
    } else {
      dfdOptions.resolve();
    }

    return dfdOptions.promise;
  }

  function _handleExpand() {
    if (!vm.hasData) {
      return _refreshAssessmentThreats().then(() => {
        vm.hasData = true;
      });
    }
    return Promise.resolve();
  }

  function _handlePerformThreatAssessment($event) {
    loaderService.showViewLoader = true;
    _refreshAssessmentThreats().then(() => {
      ssDialogService.dialogs.bcp.performThreatAssessmentDialog = ssDialogService.alert(
        performThreatAssessmentDialog.getOptions($event, {
          assessmentId: vm.assessmentId,
          threatOptions: vm.threatOptions,
          assessmentThreats: vm.assessmentThreats,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.bcp.performThreatAssessmentDialog);
    });
  }
}

EnterpriseThreatAssessmentController.$inject = [
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'performThreatAssessmentDialog',
  'ssDialogService',
  'userService'
];
